import { React, useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./fortune-service-style.css";
import ConsultFloatButton from "../../custom/consult-float-button/consult-float-button";
import SiteFooter from "../../custom/site-footer/site-footer";
import PageSeo from "../../custom/page-seo/page-seo";
import useIsMobile from "../../../hooks/useIsMobile";

const FortuneServicePageComponent = ({
  setShowServiceMenu,
  setShowPersonalMenu,
}) => {
  const isMobile = useIsMobile();
  const sectionRefs = useRef([]);

  const location = useLocation();
  let navigate = useNavigate();
  const index = location.state?.index;

  //滾動到指定 section：扣掉 fixed nav 高度，避免 section 被 nav 蓋住
  //  web 用 .dashboard nav、mobile 用 .mobile-dashboard nav（與 family-enter / flow-enter 同寫法）
  const scrollTo = (key) => {
    const el = sectionRefs.current[key];
    if (!el) return;
    const nav = document.querySelector(
      isMobile ? ".mobile-dashboard nav" : ".dashboard nav",
    );
    const navH = nav?.offsetHeight ?? 0;
    const top = el.getBoundingClientRect().top + window.scrollY - navH;
    window.scrollTo({ top, behavior: "smooth" });
  };

  //雙保險：mount 後 50ms + 250ms 各跑一次，避免 layout / 圖片載入造成第一次計算到舊位置
  useEffect(() => {
    if (index == null) return;
    const t1 = setTimeout(() => scrollTo(index), 50);
    const t2 = setTimeout(() => scrollTo(index), 250);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index, isMobile]);

  const handleToLoveMatch = () => {
    //先判斷是否已註冊成功
    //跳轉真愛合盤入口
    navigate("/love-enter");
  };

  const handleToFlowYear = () => {
    //先判斷是否已註冊成功
    //跳轉真愛合盤入口
    navigate("/flow-enter");
  };

  const handleToFamilyMatch = () => {
    //跳轉親子合盤入口
    navigate("/family-enter");
  };

  const handleToQimen = () => {
    //跳轉奇門遁甲入口
    navigate("/qimen-dunjia");
  };

  return (
    <div className="fortune-service">
      <PageSeo
        title="命理服務介紹"
        description="元辰雲閣命理服務全覽：流年之書、真愛合盤、親子合盤、個人命盤七大面向、專業諮詢。由資深命理師團隊操刀，提供完整且易讀的命理解析。"
        path="/fortune-service"
      />
      {/* 電腦板佈局 */}
      {!isMobile && (
        <div className="fortune-main">
          {/* 流年運勢詳批 */}
          {/* 「當這個 div 掛到畫面上時，把它存進 sectionRefs.current[0]」 */}
          <div
            className="odd-block"
            ref={(el) => {
              sectionRefs.current[0] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="display-figure">
                <img
                  src={`/images/ic-flow-year-service.png`}
                  loading="lazy"
                  alt="命理服務-流年運勢詳批"
                />
              </div>

              <div className="space"></div>

              <div className="title-des">
                <p className="slogan">流年運勢詳批</p>

                <div className="slogan-des">
                  <p className="main-slogan">掌握今年的起伏與轉機</p>

                  <p className="main-des">
                    每一年都有其專屬的能量，流年正是命理中反映該年運勢的鏡子。服務內容包含：
                    <br></br>
                    <br></br>◆ 當年度的整體運勢起伏
                    <br></br>◆ 健康、財運、愛情、事業、家庭、人際各面向詳解
                    <br></br>◆ 應注意的月份與事件提示
                    <br></br>◆ 趨吉避凶的建議與生活提醒
                    <br></br>
                    <br></br>
                    如果你感覺今年「特別卡」或想知道「何時轉運」，流年詳批就是你的年度導航。
                  </p>
                </div>

                <button onClick={handleToFlowYear}>立刻獲取</button>
              </div>
            </div>
          </div>

          {/* 十年大運詳批 */}
          {/* <div
            className="even-block"
            ref={(el) => {
              sectionRefs.current[1] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="title-des">
                <p className="slogan">十年大運詳批</p>

                <div className="slogan-des">
                  <p className="main-slogan">人生關鍵十年的命理導航</p>

                  <p className="main-des">
                    大運為命盤中最重要的流動力量，每10年轉換一次，影響層面深遠。
                    <br></br>服務內容包含：
                    <br></br>◆ 解析本階段的大運屬性與影響
                    <br></br>◆ 工作、財運、愛情、事業的長期趨勢變化
                    <br></br>◆ 什麼是此階段的發展重點與挑戰？
                    <br></br>◆ 掌握關鍵轉運點與注意事項
                    <br></br>
                    <br></br>
                    這份大運分析，適合在人生轉折處做為「長期規劃」的重要參考。
                  </p>
                </div>

                <button>立刻獲取</button>
              </div>

              <div className="space"></div>

              <div className="display-figure">
                <img
                  src={`/images/ic-big-flow-service.png`}
                  loading="lazy"
                  alt="命理服務-十年大運詳批"
                />
              </div>
            </div>
          </div> */}

          {/* 親子合盤詳批 */}
          <div
            className="even-block"
            ref={(el) => {
              sectionRefs.current[1] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="title-des">
                <p className="slogan">親子合盤</p>

                <div className="slogan-des">
                  <p className="main-slogan">
                    很多親子問題，不是不愛，而是不理解
                  </p>

                  <p className="main-des">
                    愛是本能，懂孩子需要方法。透過合盤看見彼此天性，讓教養從用力變成有方向，透過合盤可洞察：
                    <br></br>
                    <br></br>◆ 孩子的性格本質
                    <br></br>◆ 真正的天賦與潛能
                    <br></br>◆ 你們之間的相處模式
                    <br></br>◆ 衝突背後的真正原因
                    <br></br>
                    <br></br>
                    適合：想更了解孩子在想什麼、該如何教育與溝通的親子關係。
                  </p>
                </div>

                <button onClick={handleToFamilyMatch}>立刻獲取</button>
              </div>

              <div className="space"></div>

              <div className="display-figure">
                <img
                  src={`/images/ic-family-service.png`}
                  loading="lazy"
                  alt="命理服務-親子合盤"
                />
              </div>
            </div>
          </div>

          {/* 真愛合盤 */}
          <div
            className="odd-block"
            ref={(el) => {
              sectionRefs.current[2] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="display-figure">
                <img
                  src={`/images/ic-love-service.png`}
                  loading="lazy"
                  alt="命理服務-真愛合盤"
                />
              </div>

              <div className="space"></div>

              <div className="title-des">
                <p className="slogan">真愛合盤</p>

                <div className="slogan-des">
                  <p className="main-slogan">
                    你們真的合嗎？從命盤看愛情契合度
                  </p>

                  <p className="main-des">
                    八字不只能看自己，更能看你與另一半之間的相處頻率與愛情緣分，透過合盤可洞察：
                    <br></br>
                    <br></br>◆ 了解你的感情觀
                    <br></br>◆ 你在對方眼中是怎樣的人
                    <br></br>◆ 對方是怎樣的人、個性、喜好
                    <br></br>◆ 是否適合長期發展？你們相處會是什麼情況？
                    <br></br>
                    <br></br>
                    適合：交往中／考慮同居或結婚的情侶，曖昧中的對象也可以參考。
                  </p>
                </div>

                <button onClick={handleToLoveMatch}>立刻獲取</button>
              </div>
            </div>
          </div>

          {/* 友情合盤詳批 */}
          {/* <div
            className="even-block"
            ref={(el) => {
              sectionRefs.current[3] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="title-des">
                <p className="slogan">友情合盤</p>

                <div className="slogan-des">
                  <p className="main-slogan">你們真的合拍嗎？讓命盤來說話！</p>

                  <p className="main-des">
                    朋友之間也有命理相合與不合之處，分析雙方命格的互動關係，透過合盤可洞察：
                    <br></br>◆ 了解你的交友觀（主導 vs 支持）
                    <br></br>◆ 你在對方眼中是怎樣的人
                    <br></br>◆ 對方是怎樣的人、個性、喜好
                    <br></br>◆ 相處時容易出現的誤會或磨合點
                    <br></br>
                    <br></br>
                    適合：閨蜜、兄弟、同事、合作夥伴、團隊分析。
                  </p>
                </div>

                <button>立刻獲取</button>
              </div>

              <div className="space"></div>

              <div className="display-figure">
                <img
                  src={`/images/ic-friends-service.png`}
                  loading="lazy"
                  alt="命理服務-友情合盤"
                />
              </div>
            </div>
          </div> */}

          {/* 姓名分析 */}
          {/* <div
            className="odd-block"
            ref={(el) => {
              sectionRefs.current[4] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="display-figure">
                <img
                  src={`/images/ic-name-service.png`}
                  loading="lazy"
                  alt="命理服務-姓名分析"
                />
              </div>

              <div className="space"></div>

              <div className="title-des">
                <p className="slogan">姓名分析</p>

                <div className="slogan-des">
                  <p className="main-slogan">你的名字藏著什麼樣的能量密碼？</p>

                  <p className="main-des">
                    姓名影響一個人的氣場與對外表現，甚至影響命運與健康。
                    <br></br>本項目分析：
                    <br></br>◆ 姓名中的五行結構與八字是否相合
                    <br></br>◆ 筆劃吉凶、三才配置、音韻氣場分析
                    <br></br>◆ 是否容易招貴人、財運、桃花或小人
                    <br></br>◆ 有無需要微調或改名的建議
                    <br></br>
                    <br></br>
                    適合命盤不順者或想轉運者參考的姓名分析建議。
                  </p>
                </div>

                <button>立刻獲取</button>
              </div>
            </div>
          </div> */}

          {/* 奇門遁甲 */}
          <div
            className="even-block"
            ref={(el) => {
              sectionRefs.current[3] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="title-des">
                <p className="slogan">奇門遁甲</p>

                <div className="slogan-des">
                  <p className="main-slogan">轉動氣場，創造好運流動</p>

                  <p className="main-des">
                    奇門遁甲是古代帝王御用的風水術數，讓你也能掌握轉運的主動權。我們提供：
                    <br></br>
                    <br></br>◆ 時盤詳批：以時辰為單位，找出當天最佳行動時刻
                    <br></br>◆ 日盤詳批：以日期區間為單位，挑出最佳吉日
                    <br></br>◆ 開運方位與所走之門：避開漏財地，借勢使力
                    <br></br>◆ 教你如何運用奇門的時空能量
                    <br></br>
                    <br></br>
                    適合想提升運勢、轉換能量場、或正值低潮、覺得怎麼做都不順的朋友。
                  </p>
                </div>

                <button onClick={handleToQimen}>立刻獲取</button>
              </div>

              <div className="space"></div>

              <div className="display-figure">
                <img
                  src={`/images/ic-trigrams-service.png`}
                  loading="lazy"
                  alt="命理服務-十年大運詳批"
                />
              </div>
            </div>
          </div>

          {/*隱私政策與聯絡官方*/}
          <SiteFooter />
        </div>
      )}

      {/* 移動裝置佈局 */}
      {isMobile && (
        <div className="mobile-fortune-main">
          {/* 流年運勢詳批 */}
          {/* 「當這個 div 掛到畫面上時，把它存進 sectionRefs.current[0]」 */}
          <div
            className="item-block top-block "
            ref={(el) => {
              sectionRefs.current[0] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="display-figure">
                <img
                  src={`/images/ic-flow-year-service.png`}
                  loading="lazy"
                  alt="命理服務-流年運勢詳批"
                />
              </div>

              <div className="space"></div>

              <div className="title-des">
                <p className="slogan">流年運勢詳批</p>

                <div className="slogan-des">
                  <p className="main-slogan">掌握今年的起伏與轉機</p>

                  <p className="main-des">
                    每一年都有其專屬的能量，流年正是命理中反映該年運勢的鏡子。服務內容包含：
                    <br></br>
                    <br></br>◆ 當年度的整體運勢起伏
                    <br></br>◆ 健康、財運、愛情、事業、家庭、人際各面向詳解
                    <br></br>◆ 應注意的月份與事件提示
                    <br></br>◆ 趨吉避凶的建議與生活提醒
                    <br></br>
                    <br></br>
                    如果你感覺今年「特別卡」或想知道「何時轉運」，流年詳批就是你的年度導航。
                  </p>
                </div>

                <button onClick={handleToFlowYear}>立刻獲取</button>
              </div>
            </div>
          </div>

          {/* 十年大運詳批 */}
          {/* <div
            className="item-block even-block"
            ref={(el) => {
              sectionRefs.current[1] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="display-figure">
                <img
                  src={`/images/ic-big-flow-service.png`}
                  loading="lazy"
                  alt="命理服務-十年大運詳批"
                />
              </div>

              <div className="title-des">
                <p className="slogan">十年大運詳批</p>

                <div className="slogan-des">
                  <p className="main-slogan">人生關鍵十年的命理導航</p>

                  <p className="main-des">
                    大運為命盤中最重要的流動力量，每10年轉換一次，影響層面深遠。
                    <br></br>服務內容包含：
                    <br></br>◆ 解析本階段的大運屬性與影響
                    <br></br>◆ 工作、財運、愛情、事業的長期趨勢變化
                    <br></br>◆ 什麼是此階段的發展重點與挑戰？
                    <br></br>◆ 掌握關鍵轉運點與注意事項
                    <br></br>
                    <br></br>
                    這份大運分析，適合在人生轉折處做為「長期規劃」的重要參考。
                  </p>
                </div>

                <button>立刻獲取</button>
              </div>
            </div>
          </div> */}

          {/* 親子合盤 */}
          <div
            className="item-block even-block"
            ref={(el) => {
              sectionRefs.current[1] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="display-figure">
                <img
                  src={`/images/ic-family-service.png`}
                  loading="lazy"
                  alt="命理服務-親子合盤"
                />
              </div>

              <div className="title-des">
                <p className="slogan">親子合盤</p>

                <div className="slogan-des">
                  <p className="main-slogan">
                    很多親子問題，不是不愛，而是不理解
                  </p>

                  <p className="main-des">
                    八字不只能看自己，更能看你與另一半之間的相處頻率與愛情緣分，透過合盤可洞察：
                    <br></br>
                    <br></br>◆ 孩子的性格本質
                    <br></br>◆ 真正的天賦與潛能
                    <br></br>◆ 你們之間的相處模式
                    <br></br>◆ 衝突背後的真正原因
                    <br></br>
                    <br></br>
                    適合：想更了解孩子在想什麼、該如何教育與溝通的親子關係。
                  </p>
                </div>

                <button onClick={handleToFamilyMatch}>立刻獲取</button>
              </div>
            </div>
          </div>

          {/* 真愛合盤 */}
          <div
            className="item-block"
            ref={(el) => {
              sectionRefs.current[2] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="display-figure">
                <img
                  src={`/images/ic-love-service.png`}
                  loading="lazy"
                  alt="命理服務-真愛合盤"
                />
              </div>

              <div className="space"></div>

              <div className="title-des">
                <p className="slogan">真愛合盤</p>

                <div className="slogan-des">
                  <p className="main-slogan">
                    你們真的合嗎？從命盤看愛情契合度
                  </p>

                  <p className="main-des">
                    八字不只能看自己，更能看你與另一半之間的相處頻率與愛情緣分，透過合盤可洞察：
                    <br></br>
                    <br></br>◆ 了解你的感情觀
                    <br></br>◆ 你在對方眼中是怎樣的人
                    <br></br>◆ 對方是怎樣的人、個性、喜好
                    <br></br>◆ 是否適合長期發展？你們相處會是什麼情況？
                    <br></br>
                    <br></br>
                    適合：交往中／考慮同居或結婚的情侶，曖昧中的對象也可以參考。
                  </p>
                </div>

                <button onClick={handleToLoveMatch}>立刻獲取</button>
              </div>
            </div>
          </div>

          {/* 友情合盤詳批 */}
          {/* <div
            className="item-block even-block"
            ref={(el) => {
              sectionRefs.current[3] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="display-figure">
                <img
                  src={`/images/ic-friends-service.png`}
                  loading="lazy"
                  alt="命理服務-友情合盤"
                />
              </div>

              <div className="title-des">
                <p className="slogan">友情合盤</p>

                <div className="slogan-des">
                  <p className="main-slogan">你們真的合拍嗎？讓命盤來說話！</p>

                  <p className="main-des">
                    朋友之間也有命理相合與不合之處，分析雙方命格的互動關係，透過合盤可洞察：
                    <br></br>◆ 了解你的交友觀（主導 vs 支持）
                    <br></br>◆ 你在對方眼中是怎樣的人
                    <br></br>◆ 對方是怎樣的人、個性、喜好
                    <br></br>◆ 相處時容易出現的誤會或磨合點
                    <br></br>
                    <br></br>
                    適合：閨蜜、兄弟、同事、合作夥伴、團隊分析。
                  </p>
                </div>

                <button>立刻獲取</button>
              </div>
            </div>
          </div> */}

          {/* 姓名分析 */}
          {/* <div
            className="item-block"
            ref={(el) => {
              sectionRefs.current[4] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="display-figure">
                <img
                  src={`/images/ic-name-service.png`}
                  loading="lazy"
                  alt="命理服務-姓名分析"
                />
              </div>

              <div className="space"></div>

              <div className="title-des">
                <p className="slogan">姓名分析</p>

                <div className="slogan-des">
                  <p className="main-slogan">你的名字藏著什麼樣的能量密碼？</p>

                  <p className="main-des">
                    姓名影響一個人的氣場與對外表現，甚至影響命運與健康。
                    <br></br>本項目分析：
                    <br></br>◆ 姓名中的五行結構與八字是否相合
                    <br></br>◆ 筆劃吉凶、三才配置、音韻氣場分析
                    <br></br>◆ 是否容易招貴人、財運、桃花或小人
                    <br></br>◆ 有無需要微調或改名的建議
                    <br></br>
                    <br></br>
                    適合命盤不順者或想轉運者參考的姓名分析建議。
                  </p>
                </div>

                <button>立刻獲取</button>
              </div>
            </div>
          </div> */}

          {/* 奇門遁甲 */}
          <div
            className="item-block even-block shadow-block"
            ref={(el) => {
              sectionRefs.current[3] = el;
            }}
            onMouseEnter={() => {
              setShowPersonalMenu(false);
              setShowServiceMenu(false);
            }}
          >
            <div className="inner">
              <div className="display-figure">
                <img
                  src={`/images/ic-trigrams-service.png`}
                  loading="lazy"
                  alt="命理服務-奇門遁甲"
                />
              </div>

              <div className="title-des">
                <p className="slogan">奇門遁甲</p>

                <div className="slogan-des">
                  <p className="main-slogan">轉動氣場，創造好運流動</p>

                  <p className="main-des">
                    奇門遁甲是古代帝王御用的風水術數，讓你也能掌握轉運的主動權。我們提供：
                    <br></br>
                    <br></br>◆ 時盤詳批：以時辰為單位，找出當天最佳行動時刻
                    <br></br>◆ 日盤詳批：以日期區間為單位，挑出最佳吉日
                    <br></br>◆ 開運方位與所走之門：避開漏財地，借勢使力
                    <br></br>◆ 教你如何運用奇門的時空能量
                    <br></br>
                    <br></br>
                    適合想提升運勢、轉換能量場、或正值低潮、覺得怎麼做都不順的朋友。
                  </p>
                </div>

                <button onClick={handleToQimen}>立刻獲取</button>
              </div>
            </div>
          </div>

          {/*隱私政策與聯絡官方*/}
          <SiteFooter />
        </div>
      )}

      <ConsultFloatButton />
    </div>
  );
};

export default FortuneServicePageComponent;
